import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import { BonusStatusEnums } from 'config/types/bonus'
import { BoosterWagerBonus, UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import { Trans } from 'react-i18next'
import { formatDisplayDate } from 'utils/dateHelper'
import { useDisplayBonusName } from 'views/BonusCenter/hooks'
import TxIDBonusSection from '../../TxIDBonusSection/TxIDBonusSection'

interface BoosterBonusDetailsSectionProps {
  bonus: BoosterWagerBonus
}

const BoosterBonusDetailsSection: React.FC<BoosterBonusDetailsSectionProps> = ({ bonus }) => {
  const [name] = useDisplayBonusName(bonus.info?.name)

  return (
    <Box>
      <Text fontSize="16px" fontWeight="600" mb="4px" color="textTeriary">
        {name}
      </Text>
      <Flex mb="4px">
        <Text color="textSubtle" fontSize="12px" fontWeight="500">
          <Trans>Valid until</Trans>:
        </Text>
        <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
          {formatDisplayDate(new Date(bonus.condition.expiryDate))}
        </Text>
      </Flex>

      {bonus.status === BonusStatusEnums.Available && (
        <>
          <Flex mb="4px">
            <Text color="textSubtle" fontSize="12px" fontWeight="500">
              <Trans>Max Boostable</Trans>:
            </Text>
            <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
              {`$${bonus.maxBooster}`}
            </Text>
          </Flex>
          {!bonus.condition.isExpired && (
            <Flex mb="4px">
              <Text color="textSubtle" fontSize="12px" fontWeight="500">
                <Trans>Active time</Trans>:
              </Text>
              <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
                {`${bonus.boostHourDuration}h`}
              </Text>
            </Flex>
          )}
        </>
      )}

      {bonus.status === BonusStatusEnums.Active && (
        <>
          <Flex mb="4px">
            <Text color="textSubtle" fontSize="12px" fontWeight="500">
              <Trans>Boosted amount</Trans>:
            </Text>
            <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
              {`$${bonus.boostedAmount}`}
            </Text>
          </Flex>
          <Flex mb="4px">
            <Text color="textSubtle" fontSize="12px" fontWeight="500">
              <Trans>Max</Trans>:
            </Text>
            <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
              {`$${bonus.maxBooster}`}
            </Text>
          </Flex>
        </>
      )}

      {bonus.status === BonusStatusEnums.Used && (
        <>
          <Flex mb="4px">
            <Text color="textSubtle" fontSize="12px" fontWeight="500">
              <Trans>Boosted amount</Trans>:
            </Text>
            <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
              {`$${bonus.boostedAmount}`}
            </Text>
          </Flex>
          <Flex mb="4px">
            <Text color="textSubtle" fontSize="12px" fontWeight="500">
              <Trans>Max</Trans>:
            </Text>
            <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
              {`$${bonus.maxBooster}`}
            </Text>
          </Flex>
        </>
      )}

      {bonus instanceof UserBonus && <TxIDBonusSection bonus={bonus} />}
    </Box>
  )
}

export default BoosterBonusDetailsSection
